import { Component, OnInit } from '@angular/core';
import { Item } from '../item';
import { ItemService } from '../item.service';
import { ItemListPipe } from '../../pipe/item.pipe';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.css']
})
export class ItemListComponent implements OnInit {

  SerchText:string ='';
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  item = new Item();  //Po is defined from abobe import po
  items: Item[];
  submitted = false;
	message: string;	
	totalrecord:number;
 itemFilter: any = { itemname: '' };
  constructor(
    private itemService: ItemService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getItems();
  }
  getItems() {
    this.spinnerService.show();
    return this.itemService.getItems()
               .subscribe(
                items => {
                  console.log(items);
                  this.items = items
          this.totalrecord = this.items.length;
          this.spinnerService.hide();
                 }
                );
 }

 update(): void {
  this.submitted = true;
  this.itemService.updateItem(this.item)
      .subscribe(() => this.message = "Item Updated Successfully!");
}

delete(itemid): void {
  //this.submitted = true;
  this.itemService.deleteItem(itemid)
      .subscribe(()=> this.message = "Item Deleted Successfully!");
  this.getItems();   
}


public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}


}
